import { render, staticRenderFns } from "./Bar2.vue?vue&type=template&id=ddf66c9e&scoped=true"
import script from "./Bar2.vue?vue&type=script&lang=js"
export * from "./Bar2.vue?vue&type=script&lang=js"
import style0 from "./Bar2.vue?vue&type=style&index=0&id=ddf66c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf66c9e",
  null
  
)

export default component.exports